import type { Routes } from "@angular/router";
import { ENABLE_CHAT } from "@ankaadia/ankaadia-shared";
import { NewUiGueteGemeinschaftLinkHandlingComponent } from "../organization-specific/guetegemeinschaft/new-ui-gueteGemeinschaftLinkHandling.component";
import { NewUiAccessDeniedComponent } from "../pages/access-denied/new-ui-access-denied.component";
import { NewUiErrorComponent } from "../pages/error/new-ui-error.component";
import { NewUiKpiComponent } from "../pages/kpi/new-ui-kpi.component";
import { NewUiLoginDeniedComponent } from "../pages/login-denied/new-ui-login-denied.component";
import { NewUiLoginComponent } from "../pages/login/new-ui-login.component";
import { NewUiLogoutComponent } from "../pages/logout/new-ui-logout.component";
import { NewUiNotFoundComponent } from "../pages/not-found/new-ui-not-found.component";
import { NewUiOrganizationLinkInvitationRedirectComponent } from "../pages/organization-link-invitation-redirect/new-ui-organization-link-invitation-redirect.component";
import { NewUiOrgSwitchComponent } from "../pages/org-switch/new-ui-org-switch.component";
import { NewUiProtectedshortLinkComponent } from "../pages/shortLink/new-ui-protectedshortLink.component";
import { NewUiShortLinkComponent } from "../pages/shortLink/new-ui-shortLink.component";
import { TalentPoolDemoRedirectComponent } from "../pages/talent-pool-demo/talent-pool-demo-redirect.component";
import { NewUiTermsAndConditionsPageComponent } from "../pages/terms-and-conditions/new-ui-terms-and-conditions-page.component";
import { NewUiPublicUnsubscribeComponent } from "../pages/unsubscribe/new-ui-public-unsubscribe.component";
import { NewUiUnsubscribeComponent } from "../pages/unsubscribe/new-ui-unsubscribe.component";
import { PermissionGuard } from "../shared/guards/permission.guard";
import { TalentPoolUiGuard } from "../shared/guards/talent-pool-ui.guard";
import { NewUiAuth0CallbackComponent } from "./auth0Callback/new-ui-auth0Callback.component";
import { NewUiLandingComponent } from "./landing/new-ui-landing.component";
import { NewUiMainComponent } from "./main/new-ui-main.component";

export const routes: Routes = [
  {
    path: "consent/:consentIdentifier/:organizationId/:consentGiverId",
    component: NewUiTermsAndConditionsPageComponent,
  },
  {
    path: "consent/:organizationId/:consentGiverId",
    component: NewUiTermsAndConditionsPageComponent,
  },
  { path: "notfound", component: NewUiNotFoundComponent },
  { path: "accessdenied", component: NewUiAccessDeniedComponent },
  { path: "logindenied", component: NewUiLoginDeniedComponent },
  { path: "error", component: NewUiErrorComponent },
  { path: "login", component: NewUiLoginComponent },
  { path: "logout", component: NewUiLogoutComponent },
  { path: "callback", component: NewUiAuth0CallbackComponent },
  {
    path: "guetegemeinschaft/recertification/:orgId",
    component: NewUiGueteGemeinschaftLinkHandlingComponent,
    canActivate: [PermissionGuard],
  },
  {
    path: "guetegemeinschaft/recertification",
    component: NewUiGueteGemeinschaftLinkHandlingComponent,
    canActivate: [PermissionGuard],
  },
  {
    path: "guetegemeinschaft/newRecertification",
    component: NewUiGueteGemeinschaftLinkHandlingComponent,
  },
  {
    path: "organization-link-invitation/:organizationId/:id/:token",
    component: NewUiOrganizationLinkInvitationRedirectComponent,
    canActivate: [PermissionGuard],
  },
  {
    path: "switch/:orgId",
    component: NewUiOrgSwitchComponent,
    canActivate: [PermissionGuard],
  },
  {
    path: "switch/:orgId/:href",
    component: NewUiOrgSwitchComponent,
    canActivate: [PermissionGuard],
  },
  {
    path: "unsubscribe",
    component: NewUiUnsubscribeComponent,
    canActivate: [PermissionGuard],
  },
  { path: "unsubscribe/:orgId/:candidateId", component: NewUiPublicUnsubscribeComponent },
  { path: "s/:hash", component: NewUiShortLinkComponent },
  {
    path: "p/:hash",
    component: NewUiProtectedshortLinkComponent,
    canActivate: [PermissionGuard],
  },
  {
    // Public (anonymous) Talent-Pool pages. Whether pool data is served is gated
    // server-side per stage/organization, so the route itself stays registered.
    path: "talent-pool",
    loadChildren: () => import("../features/talent-pool/talent-pool-public.routes").then((m) => m.routes),
  },
  {
    path: "candidate-application",
    loadChildren: () =>
      import("../features/candidate-application-mask/candidate-application-mask.routes").then((m) => m.routes),
  },
  { path: "kpi", component: NewUiKpiComponent },
  {
    path: "talent-pool-demo",
    component: TalentPoolDemoRedirectComponent,
  },
  {
    path: "app",
    component: NewUiMainComponent,
    canActivate: [PermissionGuard],
    children: [
      {
        path: "",
        component: NewUiLandingComponent,
        canActivate: [PermissionGuard],
      },
      {
        path: "candidates",
        loadChildren: () => import("../features/candidates/candidates.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "collections",
        loadChildren: () => import("../features/collections/collections.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "settings",
        children: [
          {
            path: "organizations",
            loadChildren: () => import("../features/organizations/organizations.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "dashboard-widget",
            loadChildren: () => import("../features/dashboard-widget/dashboard-widget.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "user-groups",
            loadChildren: () => import("../features/user-groups/user-groups.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "users",
            loadChildren: () => import("../features/users/users.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "consent",
            loadChildren: () => import("../features/consent/consents.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "audit-definitions",
            loadChildren: () => import("../features/audit-definitions/audit-definitions.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "document-requirements",
            loadChildren: () =>
              import("../features/document-requirements/document-requirement.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "system",
            loadChildren: () => import("../features/organizations/organizations.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "candidate-profile-config",
            loadChildren: () =>
              import("../features/candidate-profile-config/candidate-profile-config.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "local-partner-profile-config",
            loadChildren: () =>
              import("../features/local-partner-profile-config/local-partner-profile-config.routes").then(
                (m) => m.routes
              ),
            canActivate: [PermissionGuard],
          },
          {
            path: "candidate-application-mask",
            loadChildren: () =>
              import("../features/candidate-application-mask-config/candidate-application-mask-config.routes").then(
                (m) => m.routes
              ),
            canActivate: [PermissionGuard],
          },
          {
            path: "vaccination-config",
            loadChildren: () =>
              import("../features/required-vaccinations/required-vaccinations.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "process-models",
            loadChildren: () => import("../features/process-models/process-models.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "professions",
            loadChildren: () => import("../features/profession/profession.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "ankaadia-tools",
            loadChildren: () => import("../features/ankaadia-tools/ankaadia-tools.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "icon-browser",
            loadChildren: () => import("../shared/icons/icon-browser.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "accounting",
            loadChildren: () => import("../features/accounting/accounting.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "plans",
            loadChildren: () => import("../features/plans/plans.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "professional-fields",
            loadChildren: () =>
              import("../features/professional-field/professional-field.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "sharing-presets",
            loadChildren: () => import("../features/sharing-preset/sharing-preset.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "organization-tags",
            loadChildren: () => import("../features/organization-tag/organization-tag.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "online-applications",
            loadChildren: () =>
              import("../features/online-application/online-application.routes").then((m) => m.routes),
          },
          {
            path: "add-on-services",
            loadChildren: () => import("../features/add-on-services/add-on-services.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          {
            path: "api-config",
            loadChildren: () => import("../features/api-config/api-config.routes").then((m) => m.routes),
            canActivate: [PermissionGuard],
          },
          ...(ENABLE_CHAT
            ? [
                {
                  path: "chat",
                  loadChildren: () => import("../features/chat/chat.routes").then((m) => m.configRoutes),
                  canActivate: [PermissionGuard],
                },
              ]
            : []),
        ],
      },
      {
        path: "activity",
        loadChildren: () => import("../features/activity/activity.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "notifications",
        loadChildren: () => import("../features/notifications/notification.routes").then((m) => m.routes),
      },
      {
        path: "dashboard",
        loadChildren: () => import("../features/dashboard/dashboard.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "processes",
        loadChildren: () => import("../features/process/process.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "process-models",
        loadChildren: () => import("../features/process-models/process-models.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "process-actions",
        loadChildren: () => import("../features/process-actions/process-actions.routes").then((m) => m.routes),
      },
      {
        path: "email-send-out-rules",
        loadChildren: () =>
          import("../features/email-send-out-rules/email-send-out-rules.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "task-delegation-rules",
        loadChildren: () =>
          import("../features/task-delegation-rules/task-delegation-rules.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "profile",
        loadChildren: () => import("../features/candidate-profile/candidate-profile.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "employers",
        loadChildren: () => import("../features/employer/employer.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "documents",
        loadChildren: () => import("../features/candidate-documents/candidate-documents.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "terms-and-conditions",
        loadChildren: () => import("../features/user-consent/user-consent.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "documents",
        loadChildren: () => import("../features/documents/documents.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "labor-agreements",
        loadChildren: () => import("../features/labor-agreements/labor-agreement.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "education",
        loadChildren: () => import("../features/education/education.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
      {
        path: "talent-pools",
        loadChildren: () => import("../features/talent-pool/talent-pool.routes").then((m) => m.routes),
        canActivate: [PermissionGuard, TalentPoolUiGuard],
      },
      ...(ENABLE_CHAT
        ? [
            {
              path: "chats",
              loadChildren: () => import("../features/chat/chat.routes").then((m) => m.routes),
              canActivate: [PermissionGuard],
            },
          ]
        : []),
      {
        path: "settings-menu",
        loadChildren: () => import("../features/settings-menu/new-ui-settings-menu.routes").then((m) => m.routes),
        canActivate: [PermissionGuard],
      },
    ],
  },
  { path: "", redirectTo: "/app", pathMatch: "full" },
  { path: "**", redirectTo: "/notfound" },
];
